import React, { useEffect, useMemo } from 'react';
import FormSelect from 'components/Select/FormSelect';
import { Rule } from 'antd/lib/form';
import { IItemForGetShortInfo, IGetVideoCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getVideoCategoriesShortInfo } from 'backend/videos';
import { TEditVideoSelectedItem } from 'modules/Entertainment/Videos/EditVideo/editVideoState/editVideoContext';
import { useTranslation } from 'react-i18next';

interface ICategorySelect {
	setIDCategory: (value: TEditVideoSelectedItem) => void;
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
}

const CategorySelect: React.FC<ICategorySelect> = ({ setIDCategory, setFetchedCategories }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetVideoCategoriesShort, void>(
		getVideoCategoriesShortInfo,
	);
	const { t } = useTranslation('error');

	useEffect(() => {
		if (response) {
			setFetchedCategories(response.data.videoCategories);
		}
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategory') }], [t]);

	return (
		<FormSelect
			testId="CategorySelect"
			name="IDSelectedCategory"
			label="categoryLabel"
			options={response?.data.videoCategories}
			fetchError={responseError}
			loading={loading}
			disabled={loading}
			onRefetch={refetch}
			onChange={setIDCategory}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CategorySelect);
